module.exports = __webpack_public_path__ + "static/media/VIA2.6b1b2ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/VIA2.png
// module id = 562
// module chunks = 1